// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__HHtRv","header":"style_header__TI90a","headline":"style_headline__BvUiE","goBack":"style_goBack__BSwaG","icon":"style_icon__AgjoZ"};